module.exports = __webpack_public_path__ + "img/hand-fingers-crossed.a397072c.svg";